<template>
<div id="page-home" class="container">
    <div class="row">
        <div class="col-xs-12 header">
            <div class="row">
                <div class="col-xs-12 top">
                    <!-- <div class="button button-center back" @click="back()"><i class="iconify icon:ic:round-keyboard-backspace"></i></div> -->
                    <div class="options"></div>
                    <div class="options"></div>
                </div>
            </div>
        </div>

        <div class="col-xs-12 releases">
            <div class="row">
                <div class="main-top col-xs-12">
                    <h3 class="feed-title">Releases.</h3>
                    <default-genre-and-region class="default-genre"></default-genre-and-region>
                </div>

                <div class="col-xs-12 clearfix">
                    <ul class="page-tabs c3">
                        <li @click="changeTab('#feed')" :class="{'active' : isTab('#feed')}">Song Feed</li>
                        <li @click="changeTab('#trending')" :class="{'active' : isTab('#trending')}">Trending</li>
                        <li @click="changeTab('#charts')" :class="{'active' : isTab('#charts')}">Charts</li>
                    </ul>
                </div>

                <div class="col-xs-12 tab-content">
                    <song-list v-if="isTabRendered('#feed')" v-show="isTab('#feed')" filter="Home" playlist-name="Song Feed" tabid="tab-feed" origin="home.Song Feed Box"></song-list>
                    <song-list v-if="isTabRendered('#trending')" v-show="isTab('#trending')" filter="ReceivedAsTrending" playlist-name="Trending" tabid="tab-trending" layout="default" showData="trending" header="trending" origin="home.Trending Box"></song-list>
                    <charts-list v-if="isTabRendered('#charts')" v-show="isTab('#charts')" :tabid="'tab-charts'" layout="charts" origin="home.Charts Box"></charts-list>
                </div>
            </div>
        </div>
  
        <div class="col-xs-12 footer">
            <div class="row">
                <div class="col-xs-12 clearfix">
                    <ul class="page-tabs c3 lightgreen">
                        <li @click="changeTab('#spotlight', 1)" :class="{'active' : isTab('#spotlight', 1)}">Spotlight</li>
                        <li @click="changeTab('#suggestions', 1)" :class="{'active' : isTab('#suggestions', 1)}">
                            Suggestions
                            <span class="unread" v-show="newSuggestions">{{ newSuggestions }}</span>
                        </li>
                    </ul>
                </div>

                <div class="col-xs-12 tab-content">
                    <spotlight v-if="isTabRendered('#spotlight', 1)" v-show="isTab('#spotlight', 1)" filter="Home" playlist-name="Song Feed" tabid="tab-spotlight"></spotlight>
                    <suggestions v-if="isTabRendered('#suggestions', 1)" v-show="isTab('#suggestions', 1)" filter="ReceivedAsTrending" playlist-name="Suggested" tabid="tab-suggestions" :new-suggestions="newSuggestions"></suggestions>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    components: {
        'song-list': require('@/components/Song/List.vue').default,
        'charts-list': require('@/components/Suggestions/Charts.vue').default,
        'default-genre-and-region': require('@/components/Home/DefaultGenreAndRegion.vue').default,
        'spotlight': require('@/components/Home/Spotlight.vue').default,
        'suggestions': require('@/components/Home/Suggestions.vue').default,
    },

    data() {
        return {
            tab: [{
                active:'#feed',
                rendered: {
                    '#feed': true,
                    '#trending': false,
                    '#charts': false,
                }
            },{
                active:'#spotlight',
                rendered: {
                    '#spotlight': true,
                    '#suggestions': false,
                }
            }],

            newSuggestions: 0,
        }
    }, 

    mounted() {
        if (App.allowGtag) gtag('config', 'UA-152097964-2', {
            'page_path' : "/home",
            'page_location': "/home",
            'page_title' : "Home"
        });

        this.$root.$on('suggestions-badges', this.getSuggestionsBadges);
        this.$root.$emit('suggestions-badges', {action: 'ask'});
    },

    methods: {
        isTab(tab, index = 0) {
            return this.tab[index].active == tab;
        },

        isTabRendered(tab, index = 0) {
            return this.tab[index].rendered[tab];
        },

        changeTab(tab, index = 0) {
            this.tab[index].active = tab;
            this.tab[index].rendered[tab] = true;

            if (App.allowGtag) gtag('config', 'UA-152097964-2', {
                'page_path' : "/home/" + tab.slice(1),
                'page_location': "/home/" + tab,
                'page_title' : "Home > " + tab.charAt(1).toUpperCase() + tab.slice(2),
            });           
        },

        getSuggestionsBadges(params){
            if (params.action == 'set'){
                this.newSuggestions = params.value;
            }
        },

        back(){
            setTimeout(() => {
                if ( this.$router.history.current.name && this.$router.history.current.name != 'home'){
                    this.$router.back();
                }else{
                    this.$router.back();
                    // this.$router.push('/');
                }
            }, 300);
        },
    },

    beforeDestroy() {
        this.$root.$off('suggestions-badges', this.getSuggestionsBadges);
    }
}
</script>